import { useContext } from "react";
import { TriggeredHook } from "sonobello.utilities.react";

import AppContext, { AppContextProps } from "../../../AppContext";

/** A decorator for a {@link TriggeredHook} which exposes all of {@link AppContextProps} to be mapped to the hook
 * parameters.
 */
const TriggeredHookContextDecorator =
  <TResponsePayload, TTrigger = undefined, TResponseError = boolean, THookParams = undefined>(
    triggeredHook: TriggeredHook<TResponsePayload, TTrigger, TResponseError, THookParams>,
    map: (props: AppContextProps) => THookParams
  ): TriggeredHook<TResponsePayload, TTrigger, TResponseError> =>
  () => {
    const appContextProps = useContext(AppContext);
    return triggeredHook(map(appContextProps));
  };

export default TriggeredHookContextDecorator;
